import {Component, Input, OnInit} from '@angular/core';

import {ParametroFuncao} from "../../funcao/models/parametro-funcao";

@Component({
  selector: 'parametro-funcao-detalhe',
  templateUrl: './parametro-funcao-detalhe.component.html',
  styleUrls: ['./parametro-funcao-detalhe.component.scss']
})
export class ParametroFuncaoDetalheComponent implements OnInit {

  @Input() parametros: ParametroFuncao[];
  @Input() valores: any = {};

  constructor() {
  }

  ngOnInit() {
    this.normalizeBooleanValues();
    this.normalizeNullValues();
  }

  private normalizeNullValues() {
    if (!this.valores) {
      return;
    }
    Object.keys(this.valores).filter(key => this.valores[key] === null).forEach(key => this.valores[key] = '-');
  }

  private normalizeBooleanValues() {
    if (!this.valores) {
      return;
    }
    Object.keys(this.valores).filter(key => this.valores[key] === true || this.valores[key] === false ).forEach(key => this.valores[key] = this.convertBooleanToSimNao(this.valores[key]));
  }

  verMais(param: ParametroFuncao, length: number) {
    param.tamanhoMaximoExibicao = length;
  }

  verMenos(param: ParametroFuncao) {
    param.tamanhoMaximoExibicao = 260;
  }

  tipoSimNao(value: any) {
    return this.convertBooleanToSimNao(this.valores[value]);
  }

  excetoToTipoSimNao(value: any) {
    return this.convertBooleanToSimNao(this.valores[value]?.except);
  }

  convertBooleanToSimNao(value: boolean) {
    return value === true ? "SIM" : "NÃO";
  }

  getValorItensMultiSelect(valore: any) {
    return valore?.items?.map(item => item.id)?.join(' / ');
  }

  getValorItens(valore: any) {
    if (valore instanceof Array) {
      return valore.join(' / ');
    }
    if(valore == null){
      return "-";
    }
    return valore;
  }
}
